"use strict";
/* eslint max-classes-per-file: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstraintError = exports.MissingFieldError = void 0;
class MissingFieldError extends Error {
    constructor(fieldName) {
        super(`${fieldName} is required`);
        /* Not Useless */
    }
}
exports.MissingFieldError = MissingFieldError;
class ConstraintError extends Error {
}
exports.ConstraintError = ConstraintError;
